// extracted by mini-css-extract-plugin
export default {"popupPreviewDocumentContainer":"styles_popupPreviewDocumentContainer__ka5Nb","buttonContainer":"styles_buttonContainer__-Gzwj","iconContainer":"styles_iconContainer__PDBFU"};